import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

@Injectable()
export class UtilService {
  static FormatDate(date: any): Date {
    const datePipe = new DatePipe(environment.defaultLanguage);
    date = datePipe.transform(date, environment.DateFormat);
    return date;
  }
  // For DDMMYYYY Date Format
  static FormatDateDDMMYY(date: any): Date {
    const datePipe = new DatePipe(environment.defaultLanguage);
    date = datePipe.transform(date, environment.DateFormatDMY);
    return date;
  }
  static DateWithFormat(date: any,format:string): Date {
    const datePipe = new DatePipe(environment.defaultLanguage);
    date = datePipe.transform(date, format);
    return date;
  }
  static IsValidEmail(email: string): boolean {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  static IsValidMultiEmail(email: string): boolean {
    const re = /(([a-zA-Z0-9\-?\.?]+)@(([a-zA-Z0-9\-_]+\.)+)([a-z]{2,3})(\W?[,;]\W?(?!$))?)+$/i;
    return re.test(String(email).toLowerCase());
  }

  static IsValidFloat(val: any): boolean {
    const re = /[+-]?([0-9]*[.])?[0-9]+/;
    return re.test(val);
  }
  static IsValidNumberic(val: any): boolean {
    const re = /^[0-9]*$/;
    return re.test(val);
  }

  static ParseDate(value: any): any {
    if ((typeof value === 'string') && (value.indexOf('-') > -1)) {
      const dstr = value.split('T')[0].split('-');
      const tstr = value.split('T')[1].split(':');

      const year = Number(dstr[0]);
      const month = Number(dstr[1]) - 1;
      const date = Number(dstr[2]);
      const hour = Number(tstr[0]);
      const min = Number(tstr[1]);
      const sec = Number((tstr[2].indexOf('.') > 0) ? tstr[2].split('.')[0] : tstr[2].slice(0, tstr[2].length - 1));

      return Date.UTC(year, month, date, hour, min, sec);
    }
  }

  static GetDateDifference(startDate: any, endDate: any) {
    const sDate = new Date(startDate);
    const eDate = new Date(endDate);
    return Math.floor((Date.UTC(eDate.getFullYear(), eDate.getMonth(), eDate.getDate()) - Date.UTC(sDate.getFullYear(), sDate.getMonth(), sDate.getDate())) / (1000 * 60 * 60 * 24));
  }
 static EncodeQuery(data) {
    let query = '';
    for (const d in data) {
      if (data[d] !== '') {
        query += `${encodeURIComponent(d)}=${data[d] instanceof Date ? new Date(data[d]).toISOString() : encodeURIComponent(data[d])}&`;
      }
    }
    return query.slice(0, -1)
  }
}
